import { staticPath } from  '@/utils/baseUrl.js'
// import Home from './pages/sph/home/home.vue'
import Home from './pages/home/commonHome.vue'
import BasicInfo from './pages/ks/shopManagement/basicInfo.vue'
import Order from './pages/sph/profit/order.vue'
import Refund from './pages/sph/refund/refund.vue'
import SmallsSoreCourses from './pages/sph/course/list.vue'
import AddSmallCourse from './pages/sph/course/addCourse.vue'
export const sphList =  {
        path: staticPath + 'home',
        component:Home,
        children:[
        {
            path: staticPath + 'basicInfo', // 基本信息
            component: BasicInfo,
            meta: {
                id: 3,
                title: '基本信息',
                pathName: staticPath + 'basicInfo'
            }
        },
        {
            path: staticPath + 'order', //  订单统计
            component:Order,
            meta: {
                id: 9,
                title: '订单统计',
                pathName: staticPath + 'order'
            }
        },
        {
            path: staticPath + 'refund', //  视频号专用退款订单
            component:Refund,
            meta: {
                id: 9,
                title: '退款订单',
                pathName: staticPath + 'refund'
            }
        },
        {
            path: staticPath + 'smallsSoreCourses',
            name: 'SmallsSoreCourses',
            component: SmallsSoreCourses,
            meta: {
                title: '小店课程',
                pathName: staticPath + 'smallsSoreCourses'
            }
        },
        {
            path: staticPath + 'addSmallCourse',
            name: 'AddSmallCourse',
            component: AddSmallCourse,
            meta: {
                title: '添加课程',
                pathName: staticPath + 'smallsSoreCourses'
            }
        },
        {
            path: staticPath + 'editSmallCourse/:id', // 修改课程
            component: AddSmallCourse,
            name: 'editSmallCourse',
            meta: {
                // id: 223,
                title: '编辑课程',
                pathName: staticPath + 'smallsSoreCourses'
            }
        },
    ]
}
